export const APP_RATED: string = 'APP_RATED';
export const APP_RATED_NOT_NOW: string = 'APP_RATED_NOT_NOW';
export const APP_THIRD_PARTY: string = 'APP_THIRD_PARTY';
export const DEVICE_ID: string = 'DEVICE_ID';
export const ENV_CONFIG: string = 'ENV_CONFIG';
export const LOCAL_USER: string = 'LOCAL_USER';
export const RATING_TRIGGER: string = 'RATING_TRIGGER';
export const RELOAD_APP_TRACKER: string = 'RELOAD_APP_TRACKER';
export const PAYNOW_USER_EMAIL: string = 'PAYNOW_USER_EMAIL';
